require('./value-builder.component.scss');

export class ValueBuilderController {
  constructor(
    $scope,
    $rootScope,
    $element,
    $timeout,
    $http,
    rx,
    observeOnScope,
    CurrentModelService,
    ErrorHandlerService
  ) {
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$http = $http;
    // this.selecter = this.$element.find('select');
    this.rx = rx;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentModelService = CurrentModelService;
    this.filteredSuggestions = [];
    this.suggestions = [];
    this.search = '';
    this.prevValue = [];
    this.valueObj = {};
    this.setSize(this.valie);
    document.addEventListener('click', event => {
      if (this.isOptionsOpen && !this.$element[0].contains(event.target)) {
        this.isOptionsOpen = false;
        this.search = '';
        if (!this.$rootScope.$$phase) this.$scope.$apply();
      }
    });
    this.subscriptions = [
      rx.Observable.merge(
        observeOnScope($scope, '$ctrl.multiple')
        .do(() => {
          if (this.multiple) this.search = '';
          else this.search = this.value[0];
          this.value = this.value.filter(v => v);
        }),
        $scope.$eventToObservable('searchChange')
        .debounce(100)
        .do(() => {
          if (!this.multiple) this.toggleValue(this.search, false);
        }),
      )
      .subscribe(() => {
        if (this.field && this.field.inputType == 'select') this.filterSuggestions();
        this.onChangedValue();
        // this.$timeout(() => this.onChanged(), 100);

      }),
      rx.Observable.merge(
        observeOnScope($scope, '$ctrl.field.dimension'),
        observeOnScope($scope, '$ctrl.search'),
      )
      .filter(value => this.field && value.newValue !== 'value' && value.newValue !== 'boolean')
      .do(() => {
        this.value = this.value.filter(v => v);
        // this.search = '';
        // this.value = [];
        this.loading = true;
        this.suggestions = [];
      })
      .debounce(200)
      .switchMap(() => this.getSuggestions(this.search))
      .do(() => {
        this.loading = false;

      })
      .subscribe(
        (suggestions) => {
          this.suggestions = suggestions;
          this.filterSuggestions();
          $scope.$digest();
        },
        (error) => {
          console.error(error);
          this.loading = false;
          $scope.$digest();
        },
      ),
    ];
    this.error = false;
  }

  $onInit() {
    this.setValueObject();
    // this.$element.find('.select-value').mouseleave(e => {
    //   this.setValueObject();
    //   if (this.multiple) {
    //     this.isOptionsOpen = false;
    //     this.onChangedValue();
    //     // this.$timeout(() => this.onChanged(), 100);
    //   }
    // });
  }

  $onDestroy() {
    this.subscriptions.forEach((s) => {
      if (s.dispose) s.dispose();
    });
  }

  setSize(length) {
    return this.size = length > 20 ? 20 : (length < 2 ? 2 : length);
  }

  getDropdownValue(cell) {
    if (typeof cell == 'string') {
      return {
        label: cell,
        name: cell
      };
    }
    if (this.fullDimension === 'agent_eventtype@default:agent_eventtype') {
      return {
        label: cell['agent_eventtype.description'],
        name: cell['agent_eventtype.name']
      };
    }
    const [dimName, hier] = this.fullDimension.split('@');
    let dimHier;
    let dimLevel;
    if (hier)[dimHier, dimLevel] = hier.split(':');
    const key = `${dimName}.${dimLevel}`;
    if (key in cell) {
      return {
        label: cell[key],
        name: cell[key]
      };
    } else {
      console.error(cell);
      return {
        label: '',
        name: ''
      };
    }
  }

  getSuggestions(lookup) {
    // if (!this.field) return
    if (this.field.suggestions) {
      return this.rx.Observable.of(this.field.suggestions.map(
        cell => this.getDropdownValue(cell)).filter(v => v).sort());
    }
    let url = `/analytics/values/${this.CurrentModelService.cube.name}/?drill=${this.fullDimension}&limit=100`;
    if (lookup) url = `${url}&lookup=${lookup}`;
    return this.rx.Observable.fromPromise(
        this.$http.get(url))
      .map(suggestions => suggestions.data.cells.map(
        cell => this.getDropdownValue(cell)).filter(v => v).sort());
  }

  onChangedValue() {
    this.$timeout(() => this.onChanged(), 100);
  }

  onSearchFocus() {
    // this.focused = true;
    this.isOptionsOpen = true;
  }

  onSearchBlur() {
    if (!this.multiple) this.isOptionsOpen = false;
  }

  clickToChoosen() {
    this.isOptionsOpen = true;
    this.$timeout(() => this.$element.find('input').focus(), 10);

  }

  isSelectedOption(option) {
    if (!this.valueObj) return false;
    return this.valueObj[option];
  }

  onSearchEnter(e) {
    if (e && e.keyCode != 13) return;
    this.toggleValue(this.search, false);
    if (this.multiple) this.search = '';
    this.$scope.$emit('searchChange');
  }

  onSearchChange() {
    this.$scope.$emit('searchChange');
  }

  cleanSearch() {
    this.search = '';
    this.value = [];
    this.$scope.$emit('searchChange');
  }

  get searchWidth() {
    return `${this.search.length || 1}ch`;
  }

  toggleValue(value, needDelete) {
    if (!value) return;
    if (!this.valueObj) this.setValueObject();
    if (this.multiple) {
      const hasValue = this.isSelectedOption(value);
      if (hasValue) {
        if (needDelete) this.value = this.value.filter(V => V !== value);
      } else {
        if (!this.value[0]) this.value[0] = value;
        else this.value.push(value);
      }
    } else {
      this.search = value;
      this.value[0] = value;
    }
    this.setValueObject();
    this.$scope.$emit('searchChange');

  }

  setValueObject() {
    this.valueObj = this.value ? this.value.reduce((res, v) => {
      if (v) res[v] = true;
      return res;
    }, {}) : {};
  }

  get fullDimension() {
    return this.field.dimension ? this.field.dimension : 'agent_agent@computer_name:computer_name';
  }

  get hasfilteredSuggestions() {
    return this.filteredSuggestions.length > 0;
  }

  filterSuggestions() {
    if (!(typeof this.search == 'string')) return;
    const search = this.search.toLowerCase();
    this.filteredSuggestions = this.suggestions.filter(suggestion =>
      (search ? suggestion.label.toLowerCase().includes(search) ||
        suggestion.name.toLowerCase().includes(search) : true) && !this.valueObj[suggestion]);
    this.$scope.$emit('searchChange');
  }
}

export const ValueBuilderComponent = {
  bindings: {
    value: '=',
    field: '<',
    multiple: '<',
    onChanged: '&',
  },
  template: require('./value-builder.component.html'),
  controller: ValueBuilderController,
};



// WEBPACK FOOTER //
// ./src/filter/dlp-builder/value-builder.component.js